import PageHeader from "@/components/site/PageHeader";
import { Ministries, NextSteps } from "@/components/site/Sections";
import { CTABand } from "@/components/site/AboutSections";
import { usePageMeta } from "@/lib/usePageMeta";

export default function MinistriesPage() {
  usePageMeta(
    "Ministries & Programs",
    "Explore the ministries of RE//FORM PLACE CHI — REFORMHIM men, SHEREFORMS women, NOVA young adults, RPK kids, worship, prayer, and discipleship in Chicago.",
  );
  return (
    <div data-testid="ministries-page">
      <PageHeader
        crumb="Ministries"
        eyebrow="Ministries & Programs"
        title="Every Generation."
        accent="Every Season."
        intro="From children to emerging leaders, there is a place designed for you to grow, serve, and belong."
        image="/outreach/shereforms-3.webp"
        imagePosition="center 30%"
      />
      <Ministries />
      <NextSteps />
      <CTABand
        eyebrow="Get Involved"
        title="Ready To Serve?"
        text="Join a ministry team — worship, hospitality, media, kids, GO Teams and more."
        primary={{ to: "/serve", label: "Volunteer" }}
        secondary={{ to: "/new-here", label: "Plan Your Visit" }}
      />
    </div>
  );
}
